/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_Embed_Error_No_CaptionsInputs */



/**
* | output |
* | --- |
* | "No closed captions (608/708) or OP-47 teletext subtitles were found in this file." |
*
* @param {Cc_Embed_Error_No_CaptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cc_embed_error_no_captions = /** @type {((inputs?: Cc_Embed_Error_No_CaptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_Embed_Error_No_CaptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun sous-titre codé (608/708) ni sous-titres télétexte OP-47 n'ont été trouvés dans ce fichier.")
	if (locale === "de") return /** @type {LocalizedString} */ ("In dieser Datei wurden keine Untertitel für Hörgeschädigte (608/708) oder OP-47-Videotextuntertitel gefunden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("In questo file non sono stati trovati sottotitoli per non udenti (608/708) né sottotitoli del teletext OP-47.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В этом файле не обнаружено субтитров (608/708) или телетекстовых субтитров OP-47.")
	if (locale === "es") return /** @type {LocalizedString} */ ("En este archivo no se encontraron subtítulos ocultos (608/708) ni subtítulos de teletexto OP-47.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此文件中未找到隐藏式字幕（608/708）或 OP-47 图文电视字幕。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このファイルには、クローズドキャプション（608/708）またはOP-47テレテキスト字幕は見つかりませんでした。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस फाइल में कोई क्लोज्ड कैप्शन (608/708) या ओपी-47 टेलीटेक्स्ट सबटाइटल नहीं मिले।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foram encontradas legendas ocultas (608/708) ou legendas de teletexto OP-47 neste arquivo.")
	return /** @type {LocalizedString} */ ("No closed captions (608/708) or OP-47 teletext subtitles were found in this file.")
});